<template>
  <div>
    <Modal :options="{close:true,esc:false}" @close="$emit('close')">
      <div class="title">Slas</div>
      <div class="body">
        <div class="row">
          <div v-for="etapa in ticket.etapas" class="col-sm-4">
            <div class="card mb-4">
              <div class="card-body">
                <h5 class="card-title">{{ etapa.etapa.etapa }}</h5>
                <h6 class="card-subtitle mb-2 text-muted">Posición: {{ etapa.posicion }}</h6>
                <div class="card-text"><span class="card-info-tilte">Estatus:</span> {{ estatus(etapa.estatus) }}</div>
                <div class="card-text"><span class="card-info-tilte">Fecha inicio:</span> {{ $moment(etapa.created_at).format('dd DD MMM YYYY HH:mm a') }}</div>
                <div v-if="etapa.estatus != 1" class="card-text"><span class="card-info-tilte">Fecha cierre:</span> {{ $moment(etapa.closed_at).format('dd DD MMM YYYY HH:mm a') }}</div>
                <div class="card-text"><span class="card-info-tilte">Tiempo en etapa:</span> <span :title="calcular_tiempo_etapa(etapa.created_at, etapa.closed_at)">{{ calcular_tiempo_etapa(etapa.created_at, etapa.closed_at) }}</span></div>
              </div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="footer"></div>
    </Modal>
  </div>
</template>

<script>
  import Modal from '@/components/Modal';

  export default {
    components: {
      Modal
    }
    ,props: {
      ticket: {
        type: Object
        ,default() {
          return {
            id: null
            ,etapas: []
          }
        }
      }
    }
    ,methods: {
      calcular_tiempo_etapa(fecha_inicio, fecha_final) {
        let tiempo = this.$helper.diff_human(fecha_inicio, fecha_final);

        if (tiempo == '')
          tiempo = 'Etapa cerrada al momento';

        return tiempo;
      }
      ,estatus(estatus) {
        switch(estatus) {
          case 0:
            return 'Cancelado';
          case 1:
            return 'Activo';
          case 2:
            return 'Cerrado';
          case 3:
            return 'Caducado';
          case 4:
            return 'Con retrazo';
          case 5:
            return 'Caducado';
        }
      }
    }
  }
</script>

<style lang="scss">
  .card {
    .card-body {
      .card-text {
        background-color: #F3F3F3;
        font-size: 0.8em;
        margin-bottom: 5px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .card-info-tilte {
          width: 40%;
          background-color: #CCCCCC;
          padding: 3px 8px;
          display: inline-block;
        }
      }
    }
  }
</style>